<script lang="ts">
	import {
		addDollarSign,
		getDecimalOfToken,
		getNumBackInUnits,
		getPrecisionOfToken
	} from '$lib/util/util';
	import { quintOut } from 'svelte/easing';

	import { scale } from 'svelte/transition';
	import { pythPrices } from '../../store';
	import type { Token, TokenSymbol } from '$lib/types/tokens';
	import { optimismTokensConfig } from '$lib/tokensConfig';
	export let token: TokenSymbol = 'sUSD';
	export let balancesToParse: Record<string, Token>;
</script>

<div
	in:scale={{ duration: 250, delay: 0, opacity: 0.5, start: 0.98, easing: quintOut }}
	class=" w-full rounded-xl squircle-xl flex items-center gap-2"
>
	<img src={optimismTokensConfig[token].logo} loading="lazy" class="w-10 h-10" alt="susd" />
	<div class="flex-col">
		<div class="text-white text-sm font-semibold">{token}</div>
		<div class="text-fx-grey-300 text-sm font-semibold">
			{#if balancesToParse && balancesToParse[token]}
				{getNumBackInUnits(
					balancesToParse[token].balance,
					getDecimalOfToken(token),
					getPrecisionOfToken(token)
				)}
				{token}
			{:else}
				- {token}
			{/if}
		</div>
	</div>
	<div class="ml-auto">
		<div class="text-fx-grey-200 text-xl font-semibold">
			{#if $pythPrices && $pythPrices[token] && balancesToParse[token]}
				{addDollarSign(
					getNumBackInUnits(
						balancesToParse[token].balanceUSD,
						getDecimalOfToken(token),
						getPrecisionOfToken(token)
					)
				)}
			{:else}
				-
			{/if}
		</div>
		{#if token == 'sUSD'}
			<a
				class="ml-auto"
				rel="noreferrer"
				href="https://app.1inch.io/#/10/simple/swap/USDC/SUSD"
				target="_blank"
				><div class="flex gap-1 items-center">
					<div class="text-xxs text-fx-pink">Get sUSD</div>
				</div>
			</a>
		{/if}
	</div>
</div>
